<div class="ps-flex-container-col" style="padding: 12px">
  <h3>{{'contacts.createAddress.createAddress' | translate}}</h3>

  <mat-form-field>
    <mat-label>{{'contacts.createAddress.type' | translate}}</mat-label>
    <mat-select [(ngModel)]="address.typeId" multiple="false">
      <mat-option *ngFor="let type of addressTypes$ | async" [value]="type.OBJECT_ID">
        <img [src]="type.ICON_URL"/>
        {{type.NAME}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{'contacts.createAddress.postal' | translate}}</mat-label>
    <input matInput [(ngModel)]="address.poastalCode">
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{'contacts.createAddress.city' | translate}}</mat-label>
    <input matInput [(ngModel)]="address.city">
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{'contacts.createAddress.street' | translate}}</mat-label>
    <input matInput [(ngModel)]="address.street">
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{'contacts.createAddress.country' | translate}}</mat-label>
    <mat-select [(ngModel)]="address.countryId" multiple="false">
      <mat-option *ngFor="let country of countries$ | async" [value]="country.OBJECT_ID">
        <img [src]="country.ICON_URL"/>
        {{country.DESCRIPTION}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{'contacts.createAddress.poBox' | translate}}</mat-label>
    <input matInput [(ngModel)]="address.poBox">
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{'contacts.createAddress.description' | translate}}</mat-label>
    <input matInput [(ngModel)]="address.description">
  </mat-form-field>

  <div style="display: flex; justify-content: end">
    <button mat-button color="accent" matTooltip="{{'contacts.createAddress.discard' | translate}}" (click)="dismiss()">
      {{'contacts.createAddress.discard' | translate}}
    </button>
    <button mat-button color="accent" matTooltip="{{'contacts.createAddress.saveAddress' | translate}}"
            (click)="save()">
      {{'contacts.createAddress.save' | translate}}
    </button>
  </div>
</div>
